import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=a8048c1e&"
import script from "./approve.js?vue&type=script&lang=js&"
export * from "./approve.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports